import { FC, useState } from 'react';
import { ProductImageTypeProps } from './TypeProps';
import { MyLink } from '@ui-kit/MyLink';
import Image from 'next/image';
import config from '@app/config';

const NO_PHOTO: string = '/next/img/nophoto.png';

export const ProductImage: FC<ProductImageTypeProps> = ({ image, name, url, className }) => {
  const [srcImage, setSrcImage] = useState<string>(image);
  return (
    <MyLink className={className} href={url}>
      <Image src={`${config.baseUrl}${srcImage}`} alt={name} width={84} height={84} layout="fixed" onError={() => setSrcImage(NO_PHOTO)} />
    </MyLink>
  );
};
